import React,{useEffect,useState} from 'react';
import { Link,useParams } from 'react-router-dom';
import {unSubscribeEmailNotification} from '../../../functions/emailNotification'
import DeleteConfirm from 'components/dialogBoxes/DeleteConfirm';
import MessageBox from "components/dialogBoxes/MessageBox";

const EmailUnsubscribeConfirmation = () => {

   const { data} =  useParams();
  
  const [message, setMessage] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [showConfirm, setShowConfirm] = useState(true);
  

const setUSubscribeEmailNotificaton=async()=>{
 const res=await unSubscribeEmailNotification(data);
 console.log('setUSubscribeEmailNotificaton',res);
};

const handleConfirm = () => {
  setUSubscribeEmailNotificaton().then(res => {
    console.log('resss', res);

    const messageForUnsubscription = (
      <>
        <h5 className="pb-2">Unsubscription Confirmation</h5>
        <p>Your email notifications have been successfully unsubscribed.</p>
        <p>
          If you ever wish to re-subscribe or have any questions or concerns,
          please don't hesitate to reach out to our dedicated support team. We
          are here to assist you and ensure you have the best experience.
        </p>
      </>
    );

    setMessage(messageForUnsubscription);
    setShowConfirm(false);
  });
};

const handleCancel=()=>{
  const messageForCancelledByUser= <>
  <h5 className="pb-2">Operation Cancelled by User</h5>
  <p>The requested operation has been cancelled by the user.</p>
</>;

  setMessage(messageForCancelledByUser);
  setShowConfirm(false);
}






 return (
   <>
     <div>
       {showConfirm && (
         <DeleteConfirm
           title="Confirm Unsubscription"
           message="Do you want to unsubsribe email notification?"
           onConfirm={handleConfirm}
           onCancel={handleCancel}
         />
       )}

       {!showConfirm && ( message )}
     </div>
   </>
 );
}

export default EmailUnsubscribeConfirmation;
